import React, { useEffect, useState } from "react";
import "./view.css";
import {
  Category,
  Container,
  Content,
  Cover,
  Date,
  Dot,
  Group,
  Main,
  Read,
  Title,
  Wrapper,
} from "./ViewBlog.Elements";
import { useParams } from "react-router-dom";
import axios from "axios";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
const ViewBlog = () => {
  const [isBlogVisible, setIsBlogVisible] = useState(false);
  const [blog, setBlog] = useState();
  let { id } = useParams();
  let modifiedDate;
  let displayDate


  useEffect(() => {
    const getBlog = async () => {
      const res = await axios.get(`https://sumail-code.onrender.com/api/v1/blogs/${id}`);
      setBlog(res.data.data.blog);
      setIsBlogVisible(true);
      
    };
    getBlog();
  }, []);

  return (
    <>
      <Container>
        <Header view='blog' />
        {!isBlogVisible ? (
          <p style={{ textAlign: "center" }}>Loading...</p>
        ) : (
          <Wrapper>
            <Main>
              <Title>{blog.title}</Title>
              <Group>
                <Date>{blog.createdAt.split('T')[0]}</Date>
                <Dot>|</Dot>
                <Read>{blog.duration} min read</Read>
              </Group>
              <Cover src={blog.imageCover} alt='' />
              <Content
                className='wysiwyg'
                dangerouslySetInnerHTML={{ __html: blog.content }}
              />
            </Main>
          </Wrapper>
        )}
      </Container>
      <div style={{ backgroundColor: "#2f3133", color: "white" }}>
        <Footer />
      </div>
    </>
  );
};

export default ViewBlog;
